import type { ViewMode } from '@mona-roadmap/domain';
import { useCallback, useState } from 'react';
import { loadExpansion, saveExpansion, setAll, type ExpansionOverrides } from '../lib/expansion';

type PerView = Record<ViewMode, ExpansionOverrides>;

/** Expansion overrides per view, persisted in localStorage and keyed by node.key. */
export function useExpansion(view: ViewMode) {
  const [all, setAllState] = useState<PerView>(() => ({ 'by-goal': loadExpansion('by-goal'), 'by-epic': loadExpansion('by-epic') }));

  const update = useCallback(
    (fn: (o: ExpansionOverrides) => ExpansionOverrides) => {
      setAllState((prev) => {
        const next = fn(prev[view]);
        saveExpansion(view, next);
        return { ...prev, [view]: next };
      });
    },
    [view],
  );

  const set = useCallback((key: string, open: boolean) => update((o) => ({ ...o, [key]: open })), [update]);
  const setMany = useCallback((keys: string[], open: boolean) => update((o) => setAll(keys, open, o)), [update]);

  return { overrides: all[view], set, setMany };
}
